import { TTypeOfModalWindow } from './createFirmwareContext';
import { ICreateUpdateFirmware, TFirmwareType, IFileData } from 'types';

export enum CreateFirmwareActionTypes {
	SET_TYPE_SELECTED_FIRMWARE = 'SET_TYPE_SELECTED_FIRMWARE',
	CHANGE_NAME_OF_FIRMWARE = 'CHANGE_NAME_OF_FIRMWARE',
	CHANGE_VERSION_OF_FIRMWARE = 'CHANGE_VERSION_OF_FIRMWARE',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetTypeSelectedFirmware {
	type: CreateFirmwareActionTypes.SET_TYPE_SELECTED_FIRMWARE;
	payload: {
		typeSelectedFirmware: TFirmwareType;
	};
}

interface IChangeNameOfFirmware {
	type: CreateFirmwareActionTypes.CHANGE_NAME_OF_FIRMWARE;
	payload: {
		nameOfFirmware: string;
	};
}

interface IChangeVersionOfFirmware {
	type: CreateFirmwareActionTypes.CHANGE_VERSION_OF_FIRMWARE;
	payload: {
		versionOfFirmware: string;
	};
}

interface IChangeDescription {
	type: CreateFirmwareActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeFileHash {
	type: CreateFirmwareActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetDataForSubmit {
	type: CreateFirmwareActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateUpdateFirmware | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateFirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateFirmwareActionTypes.RESET_FIELDS;
}

export type TCreateFirmwareAction =
	| ISetTypeSelectedFirmware
	| IChangeNameOfFirmware
	| IChangeVersionOfFirmware
	| IChangeDescription
	| IChangeFileHash
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
